import request from "../../utils/request";

export function doGetAllLabels(params) {
  return request("/labels", {
    method: "GET",
    params,
  });
}

export function doCreateLabel(params) {
  return request("/labels", {
    method: "POST",
    data: params,
  });
}

export function doUpdateLabel(params) {
  return request(`/labels/${params._id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDeleteLabel(id) {
  return request(`/labels/${id}`, {
    method: "DELETE",
  });
}
